module.exports = __webpack_public_path__ + "static/media/file-text-2.61863906.svg";